import React from "react";
import {
  Box,
  Button,
  Grid,
  makeStyles,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@material-ui/core";
import { useForm, Controller } from "react-hook-form";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { KeyboardDateTimePicker } from "@material-ui/pickers";
import { yupResolver } from "@hookform/resolvers/yup";
import { useHistory } from "react-router-dom";
import * as yup from "yup";
import apiHelper from "../../../util/ApiHelper";
import _ from "lodash";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { useLoading } from "../../../util/LoadingProvider";
import UploadImage from "../UploadImage";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import editorConfiguration from "../../../util/EditorConfiguration";

const schema = yup.object().shape({
  titleEn: yup.string().required("Title is required"),
  titleTc: yup.string().required("Title is required"),
});
const useStyles = makeStyles((theme) => ({
  tabpanel: {
    background: "#FFFFFF",
  },
  textInput: {
    backgroundColor: "white",
    width: "100%",
    marginBottom: "12px",

    "& input": {
      fontSize: "14px",
    },
  },
  content: {
    "& .ck-editor__editable_inline": {
      minHeight: "200px",
    },
  },
  buttonGroup: {
    marginTop: "20px",
    textAlign: "right",
    "& button": {
      color: "#306F9D",
      fontSize: "13px",
      textTransform: "inherit",
    },
  },
  input: {
    width: "100%",
    "& button": {
      fontSize: "13px",
      lineHeight: "15px",
      width: "25%",
    },
  },
  box: {
    padding: 0,
  },
  innerBox: {
    background: "#ffffff",
    padding: theme.spacing(3),
    marginBottom: theme.spacing(4),
  },
  sectionText: {
    fontSize: "13px",
    fontWeight: 700,
    paddingLeft: "4px",
  },
  imageGallery: {
    border: "1px solid #CCCCCC",
    minHeight: "160px",
    borderRadius: "3px",
    position: "relative",
  },
  imageGalleryControl: {
    position: "relative",
    width: "100%",
    display: "flex",
    height: "40px",
    bottom: "0",
    borderTop: "1px solid #CCCCCC",
    padding: "5px",
  },
  imageGalleryBlk: {
    minHeight: "120px",
    padding: "5px",
  },
  imgPreview: {
    maxWidth: "200px",
    margin: "10px",
    display: "inline-flex",
    "& img": {
      width: "100%",
      height: "auto",
    },
  },
}));

function TabPanel(props) {
  const classes = useStyles();
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      <Box p={3} className={classes.box}>
        {children}
      </Box>
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    "aria-controls": `nav-tabpanel-${index}`,
  };
}

const defaultFormValues = {
  "titleEn": "",
  "titleTc": "",
  "subtitleEn": "",
  "subtitleTc": "",
  "image1": "",
  "image2": "",
  "image3": "",
  "contentEn": "",
  "contentTc": "",
  "highlightEn": "",
  "highlightTc": "",
};

export default function CompanyProfilePage({ disabled, ...props }) {
  const { match } = props;
  const history = useHistory();
  const classes = useStyles();
  const [language, setLanguage] = React.useState(0);
  const [defaultValues] = React.useState(defaultFormValues);
  const [data, setData] = React.useState(null);
  const { setLoading } = useLoading();
  const [formError, setFormError] = React.useState({});

  const { control, handleSubmit, getValues, setValue, reset, formState } =
    useForm({
      defaultValues,
      resolver: yupResolver(schema),
    });

  const getCompany = async () => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiff.getCompany();
      console.log(result.data);
      setData(result.data);
      reset(result.data);
      console.log("result:", result);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event, newValue) => {
    setLanguage(newValue);
  };

  const onSubmit = async (value) => {
    //for updating history culture
    try {
      setLoading(true);
      const req = {
        ...value,
      };
      const result = await apiHelper.hkiff.updateCompany(req);
      if (result.data) {
        toast.dark("Your changes are saved.");
        getCompany();
        history.push("/hkiff/company-profile");
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    console.log(formError);
    if (!_.isEqual(formError, formState.errors)) {
      setFormError(formState.errors);
      if (formState.errors?.localizations?.en) {
        setLanguage(0);
        return;
      }
      if (formState.errors?.localizations?.tc) {
        setLanguage(1);
        return;
      }
    }
  }, [formState, formError]);

  React.useEffect(() => {
    setData(defaultFormValues);
    getCompany();
  }, []);

  return (
    <div className={classes.content}>
      <Typography variant="h4" gutterBottom>
        Company Profile
      </Typography>
      <Tabs
        value={language}
        onChange={handleChange}
        aria-label="nav tabs example"
        TabIndicatorProps={{ style: { top: "0", background: "#306F9D" } }}
      >
        <Tab label="English" {...a11yProps(0)} />
        <Tab label="繁體中文" {...a11yProps(1)} />
      </Tabs>
      <form onSubmit={handleSubmit(onSubmit)}>
        <fieldset disabled={disabled} className="fieldset">
          <TabPanel value={language} index={0}>
            <Box className={classes.innerBox}>
              <Grid container direction="vertical" spacing={3}>
                <Grid item xs={12}>
                  <Controller
                    name="titleEn"
                    rules={{ required: "Required" }}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        label="Title"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        error={!!error}
                        helperText={error ? error.message : "The name is how it appears on your site."}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="subtitleEn"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        label="Subtitle"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>

                <Grid container item xs={12}>
                  <Grid item xs={12}>
                    <strong className={classes.sectionText}>Highlight</strong>
                  </Grid>
                  <Grid item xs={12}>
                    <Controller
                      name="highlightEn"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <CKEditor
                          editor={Editor}
                          config={editorConfiguration}
                          data={field.value}
                          disabled={disabled}
                          onReady={(editor) => {
                            // You can store the "editor" and use when it is needed.
                            console.log("Editor is ready to use!", editor);
                            editor.setData(
                              defaultValues.highlightEn
                            );
                          }}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            field.onChange(data);
                            // console.log({ event, editor, data });
                          }}
                          onBlur={(event, editor) => {
                            console.log("Blur.", editor);
                          }}
                          onFocus={(event, editor) => {
                            console.log("Focus.", editor);
                          }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>

                <Grid container item xs={12}>
                  <Grid item xs={12}>
                    <strong className={classes.sectionText}>Content</strong>
                  </Grid>
                  <Grid item xs={12}>
                    <Controller
                      name="contentEn"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <CKEditor
                          editor={Editor}
                          config={editorConfiguration}
                          data={field.value}
                          disabled={disabled}
                          onReady={(editor) => {
                            // You can store the "editor" and use when it is needed.
                            console.log("Editor is ready to use!", editor);
                            editor.setData(
                              defaultValues.contentEn
                            );
                          }}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            field.onChange(data);
                            // console.log({ event, editor, data });
                          }}
                          onBlur={(event, editor) => {
                            console.log("Blur.", editor);
                          }}
                          onFocus={(event, editor) => {
                            console.log("Focus.", editor);
                          }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>

                
              </Grid>


            </Box>
          </TabPanel>
          <TabPanel value={language} index={1}>
            <Box className={classes.innerBox}>
              <Grid container direction="vertical" spacing={3}>
                <Grid item xs={12}>
                  <Controller
                    name="titleTc"
                    rules={{ required: "Required" }}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        label="Title"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        error={!!error}
                        helperText={error ? error.message : "The name is how it appears on your site."}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="subtitleTc"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        label="Subtitle"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>

                <Grid container item xs={12}>
                  <Grid item xs={12}>
                    <strong className={classes.sectionText}>Highlight</strong>
                  </Grid>
                  <Grid item xs={12}>
                    <Controller
                      name="highlightTc"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <CKEditor
                          editor={Editor}
                          config={editorConfiguration}
                          data={field.value}
                          disabled={disabled}
                          onReady={(editor) => {
                            // You can store the "editor" and use when it is needed.
                            console.log("Editor is ready to use!", editor);
                            editor.setData(
                              defaultValues.highlightTc
                            );
                          }}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            field.onChange(data);
                            // console.log({ event, editor, data });
                          }}
                          onBlur={(event, editor) => {
                            console.log("Blur.", editor);
                          }}
                          onFocus={(event, editor) => {
                            console.log("Focus.", editor);
                          }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>

                <Grid container item xs={12}>
                  <Grid item xs={12}>
                    <strong className={classes.sectionText}>Content</strong>
                  </Grid>
                  <Grid item xs={12}>
                    <Controller
                      name="contentTc"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <CKEditor
                          editor={Editor}
                          config={editorConfiguration}
                          data={field.value}
                          disabled={disabled}
                          onReady={(editor) => {
                            // You can store the "editor" and use when it is needed.
                            console.log("Editor is ready to use!", editor);
                            editor.setData(
                              defaultValues.contentTc
                            );
                          }}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            field.onChange(data);
                            // console.log({ event, editor, data });
                          }}
                          onBlur={(event, editor) => {
                            console.log("Blur.", editor);
                          }}
                          onFocus={(event, editor) => {
                            console.log("Focus.", editor);
                          }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>

                
              </Grid>


            </Box>
          </TabPanel>

          <Box className={classes.innerBox}>
            <Grid container xs={12} direction="column" spacing={3}>
              <Grid item xs={12}>
                <strong className={classes.sectionText}>
                  Image
                </strong>
              </Grid>
              <Grid container item xs={12}>
                <Grid container item xs={12} spacing={3}>
                  <Grid container item xs={12}>
                    <Grid item xs={8}>
                      {data && (
                        <UploadImage
                          name="image1"
                          data={data}
                          control={control}
                          Controller={Controller}
                          setValue={setValue}
                          getValues={getValues}

                          disabled={disabled}
                          uploadLabel="Image 1"
                          changeLabel="Image 1"
                          uploadFolder="COMPANY"
                        />
                      )}
                    </Grid>
                  </Grid>
                  <Grid container item xs={12}>
                    <Grid item xs={8}>
                      {data && (
                        <UploadImage
                          name="image2"
                          data={data}
                          control={control}
                          Controller={Controller}
                          setValue={setValue}
                          getValues={getValues}

                          disabled={disabled}
                          uploadLabel="Image 2"
                          changeLabel="Image 2"
                          uploadFolder="COMPANY"
                        />
                      )}
                    </Grid>
                  </Grid>
                  <Grid container item xs={12}>
                    <Grid item xs={8}>
                      {data && (
                        <UploadImage
                          name="image3"
                          data={data}
                          control={control}
                          Controller={Controller}
                          setValue={setValue}
                          getValues={getValues}

                          disabled={disabled}
                          uploadLabel="Image 3"
                          changeLabel="Image 3"
                          uploadFolder="COMPANY"
                        />
                      )}
                    </Grid>
                  </Grid>
                  
                </Grid>
                <Grid container item xs={12} spacing={3}></Grid>
              </Grid>
            </Grid>
          </Box>
          {disabled || (
            <div className={classes.buttonGroup}>
              <Button
                style={{ marginRight: "20px" }}
                type="button"
                onClick={() => { }}
              >
                Preview
              </Button>
              <Button
                type="submit"
                variant="contained"
                disableElevation
                style={{
                  color: "white",
                  background: "#306F9D",
                  marginRight: "5px",
                  padding: "9px 16px",
                }}
              >
                Save Changes
              </Button>
              {match.params.id && (
                <Button
                  variant="contained"
                  disableElevation
                  style={{
                    color: "white",
                    background: "#962013",
                    padding: "9px 16px",
                  }}
                  onClick={() => { }}
                >
                  Delete
                </Button>
              )}
            </div>
          )}
        </fieldset>
      </form>
    </div>
  );
}
